<template>
  <div>
    <el-card :body-style="{ padding: '0px'}" style="width: calc(100% - 40px);height: 300px;margin: 0 20px">

      <el-image style="width: 100%; height: 300px" :src="title_image" fit="cover">
      </el-image>
    </el-card>

    <el-container>
      <el-aside width="calc(100% - 385px)">

        <el-container>

          <!--封面图片-->
          <el-aside width="310px">
            <div style="padding: 20px">
              <el-card :body-style="{ padding: '0px'}" style="width: 270px;height: 405px">

                <el-image style="width: 270px;height: 405px" :src="cover_image" fit="cover">
                </el-image>
              </el-card>
            </div>
          </el-aside>

          <el-main>
            <div>
              <div style="float: left;">
                <div style="height: 30px;font-weight: bold">
                <span style="font-size: 24px;margin-right: 10px">

                  {{movieData.movie_name}}
                </span>

                  <span style="font-size: 18px;margin-right: 10px">
                  {{movieData.english_name}}
                </span>

                  <span style="font-size: 16px">
                  ( {{movieData.years}} )
                </span>
                </div>

                <div class="info-container">
                  <span class="info-title">类型：</span>

                  <span class="info-title">{{movieData.category}}</span>
                </div>

                <div class="info-container">
                  <span class="info-title">地区：</span>

                  <span class="info-title">{{movieData.orgin_place}}</span>
                </div>

                <div class="info-container">
                  <div class="info-title">语言：</div>
                </div>

                <div class="info-container">
                  <div class="info-title">上映时间：</div>
                </div>

                <div class="info-container">
                  <span class="info-title">时长：</span>

                  <span class="info-title">{{movieData.duration}}分钟</span>
                </div>

                <div class="info-container">
                  <div class="info-title">发行公司：</div>
                </div>

                <div class="info-container">
                  <span class="info-title">更多片名：</span>

                  <span class="info-title">{{movieData.more_name}}</span>

                </div>

                <div class="info-container">
                  <span class="info-title">剧情简介：</span>

                  <span class="info-title">{{movieData.intro}}</span>
                </div>

                <div class="info-container">
                  <div class="info-title">导演 / 编剧 / 主演：</div>
                </div>

                <div  class='sc-list' >

                  <div  class="sc-item" v-for="(item,index) in personnelData" :key="index">

                    <PersonnelItem :data="item"></PersonnelItem>
                  </div>
                </div>

              </div>

            </div>
          </el-main>

        </el-container>

        <div style="padding: 20px" v-if="isLogin === true && movieData.files !== null">
          <VideoPlayer ref="VideoPlayer" :data="{type:'movie',content_id:content_id,files:files,series_num:showSeriesNum}"></VideoPlayer>
        </div>

        <div style="padding: 20px" v-else-if="isLogin === true && movieData.files === null">
          没有资源
        </div>

        <div style="padding: 20px" v-else>
          未登录
        </div>

      </el-aside>

      <el-main>

        <div >
          <div style="float: right">
            <el-card style="width: 160px;height: 160px">
              <div>IMDb</div>

              <span style="font-size: 80px;font-family: agency">{{movieData.imdb}}</span>
              <span style="font-size: 30px;font-family: agency">/10</span>
            </el-card>

          </div>

          <div style="float: right;margin-right: 20px">
            <el-card style="width: 160px;height: 160px">
              <div>豆瓣评分</div>

              <span style="font-size: 80px;font-family: agency">{{movieData.douban}}</span>
              <span style="font-size: 30px;font-family: agency">/10</span>
            </el-card>
          </div>

          <div>
            相关电影
          </div>

        </div>
      </el-main>
    </el-container>

<!--    <div style="float:left;width: calc(100% - 355px)">-->

<!--      -->

<!--    </div>-->

  </div>
</template>

<script>
import {getMovieDetail} from '../../../../request/api'
import Common from '../../../../js/Common'
import VideoPlayer from '../../widgets/VideoPlayer'
import PersonnelItem from './PersonnelItem'

export default {
  name: 'MovieInfo',
  components: {
    VideoPlayer,
    PersonnelItem
  },
  data () {
    return {
      isLogin: false,
      movieData: '',
      cover_image: '',
      title_image: '',
      personnelData: [],
      content_id: '',
      files: '',
      showSeriesNum: 1
    }
  },
  methods: {
    init () {
      this.isLogin = Common.isLogin()

      var params = {'movie_id': this.$route.query.movie_id}

      getMovieDetail(params).then(res => {
        console.log(res)

        if (res.code === '90') {
          this.movieData = res.data
          this.cover_image = Common.getMovieCover(this.movieData.id)
          this.title_image = Common.getMovieTitle(this.movieData.id)

          if (this.movieData.directors !== null) {
            for (var x = 0; x < this.movieData.directors.length; x++) {
              this.personnelData.push({'character': '导演', 'personnel': this.movieData.directors[x]})
            }
          }
          if (this.movieData.screenwriters !== null) {
            for (var y = 0; y < this.movieData.screenwriters.length; y++) {
              this.personnelData.push({'character': '编剧', 'personnel': this.movieData.screenwriters[y]})
            }
          }
          if (this.movieData.performers !== null) {
            for (var z = 0; z < this.movieData.performers.length; z++) {
              this.personnelData.push(this.movieData.performers[z])
            }
          }

          if (this.movieData.files !== null) {
            this.content_id = this.movieData.id
            this.files = this.movieData.files
            this.$nextTick(() => {
              this.$refs.VideoPlayer.init()
            })
          }

          if (this.$route.query.series_num !== undefined) {
            this.showSeriesNum = this.$route.query.series_num
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })
    }

  },
  created () {
    this.init()
  },
  watch: {
    '$route' (to, from) {
      this.init()
    }
  }
}
</script>

<style scoped>

.info-container{
  margin: 20px 0;
}

.info-title{
  width: 160px;
  font-weight: bold
  /*background-color: #20a0ff;*/
  /*text-align: right;*/
}

.info-detail{

}

.title-image{
  width: 100%;
  height: 300px;
  background-color: #20a0ff;
}

.title-info{
  /*width:450px;*/
  height: 93px;
  padding: 20px;
  text-align: left;
}

.sc-item{
  text-align: center;
  /*float: left;*/

  margin: 20px 20px;
  /*margin: 20px auto;*/

}
.sc-list{
  flex-wrap: wrap;
  /*margin-left:@lrwith;*/
  /*margin-right:@lrwith;*/
  display: flex;
  /*justify-content: space-around;*/
  /* !主轴水平时!决定了item在交叉轴上的对齐方式，可能的值有flex-start|flex-end|center|baseline|stretch */
  /*align-items: center;*/
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/movie/MovieInfo.vue